import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2a7ec3b1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "bg"
};
var _hoisted_2 = {
  class: "article"
};
var _hoisted_3 = {
  class: "project-title"
};
var _hoisted_4 = {
  class: "article-content"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "left"
};
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "text"
};
var _hoisted_9 = {
  class: "date"
};
var _hoisted_10 = {
  class: "right"
};
var _hoisted_11 = ["src", "alt"];
var _hoisted_12 = {
  key: 0,
  class: "align-center"
};

var _hoisted_13 = /*#__PURE__*/_createTextVNode("learn more");

import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { apiArticleList } from '@/api/article';
import { formatTimeMonthText } from '@/utils/time';
export default /*#__PURE__*/_defineComponent({
  props: {
    titleText: {
      type: String,
      default: function _default() {
        return 'Latest from Riscern';
      }
    },
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var articleList = ref([]);
    var router = useRouter(); // 监听路由变化

    watch(function () {
      return props.dataList;
    }, function (newVal) {
      articleList.value = newVal || [];
    }, {
      immediate: true,
      deep: true
    });

    function onHrefArticle() {
      // 跳转文章页面
      router.push({
        name: 'ResourcesInsights'
      });
    }

    function onHrefArticleDetail(_ref) {
      var name = _ref.name;
      // 跳转文章信息页面
      router.push('/resources/insights-detail/' + name);
    }

    onMounted(function () {
      if (props.showMore) {
        apiArticleList({
          pageNum: 1,
          pageSize: 3
        }).then(function (_ref2) {
          var data = _ref2.data;
          articleList.value = data.data || [];
        });
      }
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.titleText), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleList.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index,
          onClick: function onClick($event) {
            return onHrefArticleDetail(item);
          }
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.introduce), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatTimeMonthText)(item.createTime)), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
          src: item.pic,
          alt: item.picAlt
        }, null, 8, _hoisted_11)])], 8, _hoisted_5);
      }), 128))]), __props.showMore ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_button, {
        class: "project-btn",
        onClick: onHrefArticle
      }, {
        default: _withCtx(function () {
          return [_hoisted_13];
        }),
        _: 1
      })])) : _createCommentVNode("", true)])]);
    };
  }
});